module.exports = __webpack_public_path__ + "static/media/icon_benefit_avocado.dbd1e1f8.svg";